import React, { useEffect, useState } from 'react'
import { api } from "../../app/Api/ApiSlice"
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import Loader from "../../components/Loader"
import "./user.css"

const About = () => {
    const [userAbout, setUserAbout] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const { user } = useParams()

    useEffect(() => {
        const getUserAbout = async () => {
            try {
                setIsLoading(true)
                const response = await api.get(`/users/${user}`)
                setIsLoading(false)
                if (response.status === 200) {
                    setUserAbout(response.data)
                }
            } catch (error) {
                setIsLoading(false)
                toast.error(error.response.data.message)
            }
        }

        getUserAbout()
    }, [])
    return (
        <div className="about-wrapper">
            {isLoading && <Loader />}
            <h4 className="about-header">About</h4>
            <div className="about-info-wrapper">
                <h6 className="about-section-header">Name</h6>
                <p>{userAbout.firstname} {userAbout.lastname}</p>
            </div>
            <div className="about-info-wrapper">
                <h6 className="about-section-header">Country</h6>
                <p>{userAbout.country}</p>
            </div>
            <div className="about-info-wrapper">
                <h6 className="about-section-header">Contacts</h6>
                <p>Email: {userAbout.email}</p>
            </div>
            <div className="about-info-wrapper">
                <h6 className="about-section-header">Occupation</h6>
                <p>{userAbout?.occupation}</p>
            </div>
            <div className="about-info-wrapper">
                <h6 className="about-section-header">Languages</h6>
                <p>{userAbout?.languages}</p>
            </div>
        </div>
    )
}

export default About